import { ClientResources } from '@app/api2/api';
import * as React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

interface IBPLoadingProps {
    active?: boolean; 
}

const BPLoading: React.FunctionComponent<IBPLoadingProps> = (props) => {
    return (
        <Dimmer inverted active={props.active ?? true}>
            <Loader inverted></Loader>
        </Dimmer>
    );
};

export default BPLoading;
